// data/languages/wolof/categories/corps.ts

import { CategoryData } from '../../../../types/types';

export const corps: CategoryData = {
  'Bopp bi (Tête)': { translation: 'La tête', translationEn: 'The head', illustration: '🧠' },
  'Bët bi (Yeux)': { translation: 'Les yeux', translationEn: 'The eyes', illustration: '👁️' },
  'Bakkan bi (Nez)': { translation: 'Le nez', translationEn: 'The nose', illustration: '👃' },
  'Gémmiñ bi (Bouche)': { translation: 'La bouche', translationEn: 'The mouth', illustration: '👄' },
  'Nopp bi (Oreille)': { translation: 'L\'oreille', translationEn: 'The ear', illustration: '👂', audio: 'Wf-nopp' },
  'Loxo bi (Bras/Main)': { translation: 'Le bras/La main', translationEn: 'The arm/The hand', illustration: '💪🤚', audio: 'Wf-loxo' },
  'Tànk bi (Jambe/Pied)': { translation: 'La jambe/Le pied', translationEn: 'The leg/The foot', illustration: '🦵👣' },
  'Xol bi (Cœur)': { translation: 'Le cœur', translationEn: 'The heart', illustration: '❤️', audio: 'Wf-xol' },
  'Kanam bi (Visage)': { translation: 'Le visage', translationEn: 'The face', illustration: '😊', audio: 'Wf-kanam' },
  'Biir bi (Ventre)': { translation: 'Le ventre', translationEn: 'The belly', illustration: '🫃' },
  'Ginaw bi (Dos)': { translation: 'Le dos', translationEn: 'The back', illustration: '🦴' },
  'Baaraam bi (Doigt)': { translation: 'Le doigt', translationEn: 'The finger', illustration: '👆' },
  'Bëñ bi (Dent)': { translation: 'La dent', translationEn: 'The tooth', illustration: '🦷' },
  'Làmmiñ bi (Langue)': { translation: 'La langue', translationEn: 'The tongue', illustration: '👅' },
  'Sëq si (Cheveux)': { translation: 'Les cheveux', translationEn: 'The hair', illustration: '💇' },
  'Baarama tànk bi (Orteil)': { translation: 'L\'orteil', translationEn: 'The toe', illustration: '🦶' },
  'Yoxo bi (Ongle)': { translation: 'L\'ongle', translationEn: 'The nail', illustration: '💅' },
  'Ponk bi (Épaule)': { translation: 'L\'épaule', translationEn: 'The shoulder', illustration: '🙆' },
  'Wéñ bi (Foie)': { translation: 'Le foie', translationEn: 'The liver', illustration: '🫀' },
  'Kaw bi (Genou)': { translation: 'Le genou', translationEn: 'The knee', illustration: '🦵' },
  'Ganaar bi (Cuisse)': { translation: 'La cuisse', translationEn: 'The thigh', illustration: '🦵', audio: 'Wf-ganaar' },
  'Làmmiñ gu rëy (Gorge)': { translation: 'La gorge', translationEn: 'The throat', illustration: '🗣️' },
  'Méej mi (Menton)': { translation: 'Le menton', translationEn: 'The chin', illustration: '😊' },
  'Golo gi (Coude)': { translation: 'Le coude', translationEn: 'The elbow', illustration: '💪' },
  'Poignet bi (Poignet)': { translation: 'Le poignet', translationEn: 'The wrist', illustration: '🤚' },
  'Taali bi (Talon)': { translation: 'Le talon', translationEn: 'The heel', illustration: '🦶' },
  'Këlkël bi (Cheville)': { translation: 'La cheville', translationEn: 'The ankle', illustration: '🦶' },
  'Yaram bi (Corps)': { translation: 'Le corps', translationEn: 'The body', illustration: '🧍', audio: 'Wf-yaram' },
  'Soppi bi (Sourcil)': { translation: 'Le sourcil', translationEn: 'The eyebrow', illustration: '🤨' },
  'Xët bi (Peau)': { translation: 'La peau', translationEn: 'The skin', illustration: '🤲', audio: 'Wf-xet' }
};

export default corps;

export {};
